import React from 'react';
import { Box, Typography } from '@mui/material';
import { SparkLineChart } from '@mui/x-charts/SparkLineChart';
import { WidgetCard, WidgetEmptyState } from './WidgetCard';
import { groupRows, buildLineSeries } from './widgetData';

const SmallMultiplesWidget = ({ widget, rows }) => {
  const { title, groupField, xField, yField, limit } = widget.params || {};
  const groups = groupRows(rows, groupField);
  const entries = Array.from(groups.entries()).slice(0, limit || 6);

  if (!entries.length) {
    return (
      <WidgetCard
        title={title || 'Small Multiples'}
        subtitle={groupField}
        testId={`report-widget-${widget.id || widget.type}`}
      >
        <WidgetEmptyState message="Small multiples data is not available yet." />
      </WidgetCard>
    );
  }

  return (
    <WidgetCard
      title={title || 'Small Multiples'}
      subtitle={groupField}
      testId={`report-widget-${widget.id || widget.type}`}
    >
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 2 }}>
        {entries.map(([label, groupRowsValue]) => {
          const { series } = buildLineSeries({ rows: groupRowsValue, xField, yField });
          const data = series[0]?.data || [];
          return (
            <Box key={label} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 1 }}>
              <Typography variant="caption" sx={{ fontWeight: 600 }}>
                {label}
              </Typography>
              {data.length ? (
                <SparkLineChart data={data} height={60} />
              ) : (
                <Typography variant="caption" color="text.secondary">
                  No data
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
    </WidgetCard>
  );
};

export default SmallMultiplesWidget;
